import Vue from 'vue'
import Router from 'vue-router'
import lodash from 'lodash';
import { message } from 'ant-design-vue';
import store from '../store';
import API from '../common/api.js';
import { request,syncRequest } from './request';
import CONFIG from '../common/config.js';
import { GLOBAL } from '../common/global.func'

Vue.use(Router)

function throwError(errorMessage) {
    throw new Error(errorMessage)
}

function getFullApiUrl(type) {
    if (!type) {
        throwError('缺少type参数');
    }
    let nattypeArr = API[type];
    if(type.indexOf('jobcenter') != -1){
        //定时任务中心直掉接口
        return CONFIG.JobCenterHost(nattypeArr)
    }
    if(type.indexOf('branch/getallbranches') != -1){
        //定时任务中心直掉接口
        return CONFIG.BranchHost(nattypeArr)
    }
    nattypeArr = lodash.trimStart(nattypeArr, '/');
    let url = CONFIG.ApiNatToHost(nattypeArr);
    return url
}

/**
 * 新增数据
 */
function add({ type = null, params = {}, ...rest }) {
    const url = getFullApiUrl(type)
    return request({ url, params}).then(response => {
        const { data = {} } = response
        /**
         * showMsg 是否显示接口返回的 操作提示信息
         * 有些场景不需要直接显示, 可能需要在页面中处理其他逻辑, 那么指定showMsg为false即可
         * 例如 添加员工页面  this.D.add({...}) 中的场景
         */
        if (data.success == "1" && rest.showMsg !== false) {
            message.success("操作成功")
        }
        return response
    })
}

/**
 * 删除数据
 */
function del({ type = null, params = {} }) {
    const url = getFullApiUrl(type)
    return request({ url, params}).then(response => {
        const { data = {} } = response
        if (data.success == "1") {
            message.success("操作成功")
        }
        return response
    })
}

/**
 * 修改数据
 */
function edit({ type = null, params = {} }) {
    const url = getFullApiUrl(type)
    return request({ url, params, type }).then(response => {
        const { data = {} } = response
        if (data.success == "1") {
            message.success("操作成功")
        }
        return response
    })
}

/**
 * 查询数据(多条)
 * 可能需要额外处理分页大小  pageSize
 */
function select({ type = null, params = {} }) {
    const url = getFullApiUrl(type)
    //params.urlparams 是否需要带上URL参数? 默认为带参数
    let queryString = {}
    if (params.urlparams !== false) {
        queryString = GLOBAL.UrlQueryString();
    }
    delete params.urlparams; //删除用于判断的字段
    params = {
        ...params,
        ...queryString
    };
    params.pageSize = params.pageSize ? params.pageSize : store.state.pagesize
    return request({ url, params });
}

/**
 * 根据某条件获取数据详情
 */
function detail({ type = null, params = {} }) {
    const url = getFullApiUrl(type)
    return request({ url, params}).then(response => {
        /* const { data = {} } = response
        if (data.success == "1") {
            message.success("操作成功")
        } */
        return response
    })
}

function syncSelect({type = null,params = {}}){
    const url = getFullApiUrl(type)
    return syncRequest({url,params})
}

//暴露方法，数据的CURD操作方法
export {
    add,    //增    C
    del,    //删    D
    edit,   //改    U
    select, //查(多条)  R   
    detail,  //查(一条)  R   
    syncSelect
}
